<template>
  <!--知识库管理-->
  <div class="basePage">
    <div v-show="tableData && tableData.length > 0">
      <div style="font-size: 18px; font-weight: bold">知识库</div>
      <!--空状态-->
      <div v-show="isShowEmpty" class="emptyBox">
        <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/empty.png" />
        <p>暂无数据</p>
        <el-button type="primary" @click="addClick()">新增知识库</el-button>
      </div>
      <div v-show="!isShowEmpty" class="content">
        <div class="searchBox">
          <el-form>
            <div class="searchPox">
              <div class="liBox">
                <el-form-item label="文件名称">
                  <el-input v-model="fileName" clearable placeholder="请输入文件名称" type="text"></el-input>
                </el-form-item>
              </div>
              <div class="liBox">
                <el-form-item label="文件类型">
                  <el-select v-model="fileType" clearable placeholder="请选择文件类型">
                    <el-option :value="1" label="图片"></el-option>
                    <el-option :value="2" label="视频"></el-option>
                    <el-option :value="3" label="文档"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="liBox searchBtn">
                <el-button class="searchButton" type="primary" @click="getListFun">查询</el-button>
                <el-button :icon="Plus" type="primary" @click="addClick()"> 新建知识库 </el-button>
              </div>
            </div>
          </el-form>
        </div>
        <div class="tableBox">
          <!--列表-->
          <div class="tableBox">
            <el-table ref="multipleTableRef" v-loading="loadingVal" :data="tableData" style="width: 100%" table-layout="auto">
              <template #empty>
                <el-empty
                  class="emptyClass"
                  description="暂无数据信息"
                  image="
https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png"
                >
                  <p>您可以在此页面绑定设备</p>
                </el-empty>
              </template>
              <el-table-column label="文件名称" min-width="150px" prop="name" />
              <el-table-column label="文件类型" min-width="150px" prop="type">
                <template #default="scope">
                  <p v-show="scope.row.type == 1">图片</p>
                  <p v-show="scope.row.type == 2">视频</p>
                  <p v-show="scope.row.type == 3">文档</p>
                </template>
              </el-table-column>
              <el-table-column label="文件描述" min-width="150px" prop="fileDesc" />
              <el-table-column label="备注" min-width="150px" prop="remark" />
              <el-table-column label="更新时间" min-width="150px" prop="updateTime" sortable />
              <el-table-column fixed="right" label="操作" min-width="180px">
                <template #default="scope">
                  <ul class="operationUl">
                    <li class="editClass" @click="addClick(scope.row.id, scope.row)">编辑</li>
                    <li class="editClass" @click="delClick(scope.row.id)">删除</li>
                    <li class="editClass" @click="lookClick(scope.row.fileUrl)">查看</li>
                    <li class="editClass" @click="downloadClick(scope.row)">下载</li>
                  </ul>
                </template>
              </el-table-column>
            </el-table>
            <div class="footerBox">
              <el-pagination
                :page-size="pageSize"
                :page-sizes="[20, 100, 200, 300, 400]"
                :total="total"
                background
                layout="total,sizes, prev, pager, next"
                small
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--新增知识库-->
    <el-dialog v-model="deviceDialogVisible" :close-on-click-modal="false" :title="formData.id ? '编辑知识库' : '新增知识库'" width="40%">
      <div>
        <el-form ref="formDataRef" :model="formData" :rules="deviceRules" class="demo-ruleForm" label-width="auto" style="width: 98%">
          <el-form-item label="文件名称" prop="name">
            <el-input v-model="formData.name" placeholder="请输入文件名称" />
          </el-form-item>
          <el-form-item label="文件类型" prop="type">
            <el-select v-model="formData.type" clearable placeholder="请选择文件类型">
              <el-option :value="1" label="图片"></el-option>
              <el-option :value="2" label="视频"></el-option>
              <el-option :value="3" label="文档"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件描述">
            <el-input v-model="formData.fileDesc" placeholder="请输入文件描述" type="textarea" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="formData.remark" placeholder="请输入备注" type="textarea" />
          </el-form-item>
          <el-form-item label="附件" prop="fileUrl">
            <el-upload
              v-model:file-list="formData.fileUrl"
              :auto-upload="false"
              :on-change="uploadFile"
              accept=".jpg, .jpeg, .png,.pdf,.xls,.xlsx,.doc,.docx,.mp4"
              action="#"
              class="upload-demo"
              multiple
            >
              <el-button>点击上传</el-button>
              <template #tip>
                <div class="el-upload__tip">格式支持：文档(word、excel、pdf);视频(mp4);图片(jpg、jpeg、png)</div>
              </template>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="resetButton" @click="deviceDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="deviceSave">保存</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import { defineProps, h, onMounted, ref, watch, defineExpose } from "vue";
import { useRouter } from "vue-router/dist/vue-router";
import { delKnowledgeListApi, getKnowledgeListApi, saveKnowledgeListApi } from "@/api/modules/project";
import qs from "qs";
import { ElLoading, ElMessage, ElMessageBox } from "element-plus";
import { uploadImg } from "@/api/modules/bigScreenConfigure";

const props = defineProps(["custerObj", "dialogVisible"]);

let router = useRouter();
let route = useRouter();

let isShowEmpty = ref(true);

let custerObj = ref();

// 获取列表-------------------------------------------------------------------------
let fileName = ref();
let fileType = ref();
let pageNumber = ref(1); //页码
let pageSize = ref(20); //页数
let total = ref(0); //总页数
let tableData = ref([]); //列表数据

//每页多少
const handleSizeChange = function (val) {
  pageSize.value = val;
  getListFun();
};
//更改页数
const handleCurrentChange = function (val) {
  pageNumber.value = val;
  getListFun();
};
let loadingVal = ref(false); //表格加载
let name = ref(); //设备名称
let gatewayId = ref(); //网关id
let useStatus = ref(""); //状态
let getSubFlag = ref(true); //状态
const getListFun = async function () {
  if (custerObj.value.id) {
    loadingVal.value = true;
    let params = {
      pageNumber: pageNumber.value,
      pageSize: pageSize.value,
      projectId: custerObj.value.id,
      name: fileName.value,
      type: fileType.value,
    };
    await getKnowledgeListApi(qs.stringify(params))
      .then((res) => {
        loadingVal.value = false;
        if (res.data.ok) {
          tableData.value = res.data.result.list;
          total.value = Number(res.data.result.total);
          isShowEmpty = total.value > 0 ? false : true;
        } else {
          ElMessage({
            message: res.data.message,
            type: "error",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
};

// 新增操作-------------------------------------------------------------------------
let deviceDialogVisible = ref(false); //新增设备弹窗开关
let formDataRef = ref(); //设备
//设备表单
let formData = ref({
  id: 0,
  projectId: custerObj.value ? custerObj.value.id : null,
  name: "",
  type: "",
  fileDesc: "",
  remark: "",
  fileUrl: [],
});
// 设备表单验证规则
let deviceRules = ref({
  name: [
    {
      required: true,
      message: "请输入文件名称",
      trigger: "blur",
    },
  ],
  type: [
    {
      required: true,
      message: "请选择文件类型",
      trigger: "blur",
    },
  ],
  fileUrl: [
    {
      required: true,
      message: "请上传附件",
      trigger: "blur",
    },
  ],
});
//新增设备的点击
const addClick = function (id, row) {
  isShowEmpty = false;
  deviceDialogVisible.value = true;
  if (id) {
    formData.value = row;
    formData.value.projectId = custerObj.value.id;
    formData.value.fileUrl = [
      {
        name: row.name + "." + row.fileUrl.split(".")[row.fileUrl.split(".").length - 1],
        url: row.fileUrl,
      },
    ];
  } else {
    formData.value = {
      id: 0,
      projectId: custerObj.value.id,
      name: "",
      type: "",
      fileDesc: "",
      remark: "",
      fileUrl: "",
    };
  }
};
// 上传
const uploadFile = function (file) {
  // if ((file.size / 1024 / 1024) > 5) {
  //   ElMessage({
  //     message: '文件大小不能超过5M!',
  //     type: 'info'
  //   })
  //   formData.value.fileUrl = []
  // } else {
  let fd = new FormData();
  //注意是文件流file.raw
  fd.append("file", file.raw); //传文件
  uploadImg(fd)
    .then((res) => {
      //console.log(res);
      if (res.data.ok) {
        formData.value.fileUrl = [];
        formData.value.fileUrl.push({
          name: res.data.result.oldName,
          url: res.data.result.fullPath,
        });
      } else {
        ElMessage({
          message: res.data.message,
          type: "error",
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
  // }
};
//设备的保存
const deviceSave = function () {
  if (formDataRef) {
    formDataRef.value.validate((valid) => {
      //提交成功
      if (valid) {
        console.log({ ...formData.value, fileUrl: formData.value.fileUrl[0].url });
        saveKnowledgeListApi(qs.stringify({ ...formData.value, fileUrl: formData.value.fileUrl[0].url }))
          .then(async (res) => {
            if (res.data.ok) {
              deviceDialogVisible.value = false;
              getListFun();
            } else {
              ElMessage({
                message: res.data.message,
                type: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }
};
//删除
const delClick = function (id) {
  ElMessageBox.confirm("确认删除吗，删除后不可恢复，请谨慎操作", "", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    title: "删除知识库",
    message: h("p", null, [
      h(
        "img",
        {
          src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png",
          style: "width:20px;height:20px;transform: translateY(4px);margin-right:8px;",
        },
        ""
      ),
      h(
        "span",
        {
          style: "color:#595959;",
        },
        "请确认是否要删除此知识库，删除后数据不可恢复"
      ),
    ]),
  })
    .then(() => {
      delKnowledgeListApi(
        qs.stringify({
          id: id,
        })
      )
        .then((res) => {
          if (res.data.ok) {
            getListFun();
          } else {
            ElMessage({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    })
    .catch(() => {
      ElMessage({
        message: "已取消删除",
        type: "info",
      });
    });
};

// 加载的动画
let loadingAdd = ref();
const openFullScreen = function () {
  loadingAdd.value = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.1)",
  });
};
// 下载
const downloadClick = function (row) {
  openFullScreen();
  window.location.href = row.fileUrl;
  setTimeout(() => {
    loadingAdd.value.close();
    dialogVisible2.value = false;
    ElMessage({
      type: "success",
      message: "下载成功",
    });
  }, 1000);
  loadingAdd.value.close();
};

// 查看详情
const lookClick = function (url) {
  //要预览文件的访问地址
  window.open(`#/baseView?url=${url}`);
};

watch(
  () => props.custerObj,
  async (newValues, oldValues) => {
    custerObj.value = newValues;
    getListFun();
  },
  { immediate: true, deep: true }
);

const openDialog = () => {
  deviceDialogVisible.value = true;
};

defineExpose({ openDialog });
onMounted(() => {
  getListFun();
});
</script>

<style lang="less">
.basePage {
  background: #fff;
  width: 100%;
  //height: calc(100% - 25px);
  padding: 0;
  overflow: auto;
  //border-top: 1px solid #ECEEF6;
  margin-top: 20px;

  > .title {
    width: 100%;
    height: 20px;
    line-height: 48px;
    padding: 0;
  }

  .emptyBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 300px;
    }

    p {
      color: #999999;
    }

    .el-button {
      width: 300px;
      height: 40px;
      margin-top: 40px;
    }
  }

  .content {
    width: 100%;
    height: calc(100% - 36px);
    padding: 0;
    margin: 0;
    display: block;
    //搜索
    .searchBox {
      position: relative;
      width: 100%;
      margin-bottom: 16px;
      display: flex;

      .el-form {
        width: 100%;
        display: flex;

        .searchPox {
          //width: calc(100% - 135px);
          //display: flex;
          //flex-direction: column;

          .liBox:first-child {
            .el-form-item {
            }
          }

          .liBox {
            width: 198px;
            display: inline-block;
            margin-right: 20px;

            .el-form-item {
              display: flex;

              .el-select,
              .el-input,
              .el-input__wrapper {
                width: 128px;
              }

              .el-radio {
                margin-right: 10px;
              }
            }
          }
        }

        .searchBtn {
          width: 180px !important;

          .el-checkbox__input {
            .el-checkbox__inner {
              background-color: #165dff;
            }
          }

          .el-checkbox__input.is-focus {
            .el-checkbox__inner {
              background-color: #fff;
            }

            .el-checkbox__inner:after {
              border-color: #165dff;
            }
          }
        }
      }
    }

    /*卡片*/

    .cardBox {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .cardContent {
        position: relative;
        margin: 16px 0 0 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border: 1px solid #e5e6eb;
        width: 24%;
        min-width: 268px;
        height: 246px;
        border-radius: 6px;
        background: #ffffff;
        overflow: hidden;

        .titleBox {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: calc(100% - 44px);
          cursor: pointer;
        }

        .topBox {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;
          height: 44px;

          .leftBox {
            display: flex;
            flex-direction: column;
            padding-left: 16px;
            justify-content: space-between;

            div:nth-child(1) {
              color: #1d2129;
              font-size: 15px;
              font-weight: bold;
            }

            div:nth-child(2) {
              color: rgba(0, 0, 0, 0.4);
              font-size: 12px;
            }
          }

          .rightBox {
            margin-right: 16px;
            text-align: right;
          }
        }

        .centerBox {
          height: 41px;
          display: flex;
          justify-content: space-between;
          padding: 0 16px;

          .leftBox {
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            div:nth-child(1) {
              color: #86909c;
              font-size: 12px;
            }

            div:nth-child(2) {
              color: #1d2129;
              font-size: 14px;
            }
          }

          .rigthBox {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            text-align: right;

            div:nth-child(1) {
              color: #86909c;
              font-size: 12px;
            }

            div:nth-child(2) {
              color: #1d2129;
              font-size: 14px;
            }

            width: 36%;
          }
        }

        .bottomBox {
          height: 41px;
          background-color: #f8f9fb;
          overflow: hidden;
          display: flex;
          align-items: center;

          div {
            flex: 1;
            text-align: center;
            color: #165dff;
            font-size: 14px;
            cursor: pointer;
          }

          div:nth-child(2) {
            border-left: 1px solid rgba(0, 0, 0, 0.06);
            border-right: 1px solid rgba(0, 0, 0, 0.06);
          }

          div:last-child {
            color: #ef2121;
          }
        }
      }

      .cardContent:hover {
        box-shadow: 7px 7px 32px 0px rgba(158, 176, 207, 0.48);
      }
    }

    .cardBox.cardBox2 {
      .cardContent {
        height: 200px;
      }

      .centerBox {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: calc(100% - 58px);
        padding: 16px;

        .leftBox {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
        }
      }
    }

    .statusOnClass {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 60px;
      height: 22px;
      background: #e8ffea;
      border-radius: 3px;
      color: #00b42a;

      .dotOnClass {
        border-radius: 50%;
        width: 6px;
        height: 6px;
        background: #00b42a;
      }
    }

    .statusOutClass {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 60px;
      height: 22px;
      background: #ffece8;
      border-radius: 3px;
      color: #f53f3f;

      .dotOutClass {
        border-radius: 50%;
        width: 6px;
        height: 6px;
        background: #f53f3f;
      }
    }

    /*element表格*/

    .tableBox {
      width: 100%;
      //height: 100%;
      padding: 0 !important;
      box-shadow: 0 0 0 0 !important;

      .operationBox {
        background-color: #fff;
        display: flex;
        justify-content: space-between;

        .tabBox {
          display: flex;
          justify-content: center;
          padding: 0 4px;
          align-items: center;
          width: 138px;
          background-color: #f2f3f5;
          border-radius: 2px;

          div {
            flex: 1;
            border-radius: 2px;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            background-color: #f2f3f5;
            color: #919193;
          }

          div:nth-child(1) {
            margin-right: 4px;
          }

          .active {
            background-color: #fff;
            color: #165dff;
          }
        }
      }

      .operationUl {
        padding: 0;
        margin: 0;
        display: flex;
        //justify-content: space-between;
        align-items: center;
        width: 160px;

        .groupClass {
          width: 20px;
          height: 20px;
        }

        li {
          cursor: pointer;
          margin-right: 10px;
          margin-left: 0 !important;
          display: flex;
          align-items: center;

          img {
            width: 24px;
            height: 24px;
          }

          .is-checked {
            .el-switch__core {
              border: 1px solid #00b173;
            }

            .el-switch__action {
              background-color: #00b173;
            }
          }

          .more {
            font-size: 20px;
            font-weight: bold;
          }
        }

        li:last-child {
          margin-right: 0;
        }
      }

      .editClass {
        cursor: pointer;
        color: #165dff;
        //margin: 0 !important;
      }

      .deleteClass {
        cursor: pointer;
        color: #ef2121;
      }

      .el-table thead th {
        background: rgb(250, 250, 250);
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
      }

      .el-table__body-header .el-table__cell {
        padding: 0;
      }

      .userClass {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin-right: 4px;
      }

      .adressClass {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-left: 4px;
      }
    }

    //分页
    .footerBox {
      margin: 14px 0 0px 0;
      display: flex;
      justify-content: flex-end;
    }
  }

  //弹窗
  .dialogFormVisible {
    //min-width: 1000px;
    .el-dialog__header {
      border-bottom: 1px solid #efefef;
      margin: 0;
    }

    .el-dialog__footer {
      border-top: 1px solid #efefef;
      margin: 0;
    }

    .el-form-item {
      display: block;
      margin-bottom: 0;
      margin-right: 0;

      .el-select,
      .el-input-number {
        width: 100%;

        .el-input__inner {
          text-align: left;
        }
      }

      .el-form-item__content {
        display: block;

        .operation {
          margin: 5px 0 10px;
        }
      }

      .labelBox {
        display: flex;
        align-items: center;

        .el-icon.el-tooltip__trigger {
          margin-left: 8px;
          margin-right: 12px;
        }
      }

      .upload-demo {
        position: relative;

        .el-upload {
          width: 100%;
        }

        .uploadBox {
          width: 100%;
          height: 50px;
          line-height: 50px;
          border: 1px dashed #189bfe;
          border-radius: 8px;
          background-color: rgba(24, 155, 254, 0.05);

          .upBtnBox {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #189bfe;

            .el-icon {
              margin-right: 10px;
              font-size: 18px;
            }
          }

          .none {
            display: none;
          }
        }

        .el-upload-list {
          position: absolute;
          top: 0;
          width: 90%;
          margin-left: 5%;
        }
      }
    }

    //.formItem {
    //  .el-form-item__content {
    //    display: flex;
    //  }
    //
    //  .widthBox {
    //    flex: 1;
    //  }
    //}
    .contentItem {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      > p,
      > div {
        margin-right: 10px;
        display: flex;
        align-items: center;
      }

      .contItemBox {
        align-items: start;

        .symbol {
          margin-right: 10px;
          margin-top: 30px;
          font-size: 20px;
          text-align: center;

          p {
            cursor: pointer;
            margin: 0;
          }

          .activeSymbol {
            color: #165dff;
          }
        }

        .symbol2 {
          margin-top: 50px;
        }
      }

      .addIcon,
      .delIcon {
        font-size: 17px;
        color: #000;
        cursor: pointer;
      }

      .addBox {
        width: 160px;
        height: 160px;
        border: 1px dashed #000;
        margin: 10px 0 0 10px;
        text-align: center;
        line-height: 160px;
        font-size: 40px;
        color: #000;
        cursor: pointer;
      }

      .contItem {
        display: flex;
        flex-direction: column;
        margin: 10px 0px 10px 0;

        .el-select {
          width: 160px;
          height: 30px;
        }

        .contTime .el-input {
          width: 110px;
          height: 30px;
        }

        .el-input__wrapper {
          height: 30px;
          background-color: #f6f6f6;
          color: #ccc;
          box-shadow: 0 0 0 0;
        }

        .contBox {
          width: 140px;
          height: 100px;
          background-color: #f6f6f6;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 0 10px;
          margin: 10px 0;
          position: relative;

          .el-select {
            width: calc(100% - 17px);

            .el-input__inner {
              padding-left: 0;
              font-size: 12px;
            }
          }

          .delIcon {
            position: absolute;
            top: 5px;
            right: 5px;
            color: #ccc;
            z-index: 1;
          }

          .center {
            p {
              color: #000;
            }

            //.val .el-input__wrapper {
            //  box-shadow: 0 0 0 0;
            //  background-color: #f6f6f6;
            //}
            .val .el-input__inner {
              font-size: 24px;
              color: #000;
            }

            .val .el-input__inner::placeholder {
              font-size: 12px;
              vertical-align: middle;
            }
          }

          .unit {
            text-align: right;
          }
        }

        .contItem:hover .delIcon {
          display: block;
        }
      }
    }
  }
}
</style>
